import { useLocation } from "react-router-dom";
import { useNotifications } from "../../../providers/notificationProvider/NotificationProvider";
import { useEffect, useCallback } from "react";
import { GET_SELECTED_SHOP_ID, REQUEST } from "../../../utils/js/Const";
import { GetCookie } from "../../../utils/js/request";

export const useClaimsNotifications = () => {

    const location = useLocation();
    const { setNotification } = useNotifications();

    const fetchClaimsCount = useCallback(async () => {

        const selectedId = GET_SELECTED_SHOP_ID();
        const accessToken = GetCookie("access_token");

        if (selectedId === 0 || !accessToken) {
            console.warn('Нет данных для запроса счетчика');
            return null;
        }

        try {
            const url = `${REQUEST}/api/v1/pretensions/count?shops_id=${selectedId}`;

            const response = await fetch(
                url,
                {
                    method: "GET",
                    headers: {
                        "Accept": "application/json",
                        "Access-Token": accessToken,
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();
                const count = data.data?.count_pretensions || 0;
                setNotification('claims', count);
                return count;
            } else {
                console.warn('Ошибка при получении счетчика:', response.status);
            }
        } catch (error) {
            console.error('Error fetching claims count:', error);
        }
        return null;
    }, [setNotification]);

    useEffect(() => {
        fetchClaimsCount();
    }, [location.pathname, fetchClaimsCount]);

    return { fetchClaimsCount };
};